import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function DownArrowIcon({
  size = "8",
  color = MAIN_THEME.colors.brandGray40,
}: ISvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 8 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.97656 5C1.76562 5 1.625 5.11719 1.55469 5.30469C1.46094 5.49219 1.50781 5.65625 1.64844 5.79688L4.67188 8.82031C4.76562 8.91406 4.85938 8.96094 5 8.96094C5.11719 8.96094 5.23438 8.91406 5.32812 8.82031L8.35156 5.79688C8.49219 5.65625 8.51562 5.49219 8.44531 5.30469C8.35156 5.11719 8.21094 5 8.02344 5H1.97656Z"
        transform="translate(-1 -5)"
        fill={color}
      />
    </svg>
  );
}
